import { create } from "zustand";

const invoiceStatusStore = create((set) => ({
  invoiceStatus: 0,
  setInvoiceStatus: (invoiceStatus) => set(() => ({ invoiceStatus })),
}));

export default invoiceStatusStore;
